export default __webpack_public_path__ + "static/solutions_menu-907683410a1b906cafae797915d4d8f7.png";